import { Card, CardActions, CardContent, Dialog, Grid, Typography } from "@mui/material";
import VButton from "../Common/VButton";

const style = {
  rootContainer: {
    overflow: "auto",
    boxShadow: 0,
  },
  header: {
    mt: 2,
    mb: 3,
    fontWeight: 700,
  },
};

const EndDialog = (props: { isOpen: boolean; startTimer: () => void }) => {
  return (
    <Dialog open={props.isOpen}>
      <Card sx={style.rootContainer}>
        <CardContent>
          <Typography align="center" variant="h5" sx={style.header}>
            Sissejuhatus
          </Typography>
          <Typography paragraph>
            Proovitest annab teile võimaluse DÜKA testi formaadiga tutvuda, kuna see on seadistatud testi vaikimisi
            parameetrite alusel (sõnadevahelised intervallid on 4 sek).
          </Typography>
          <Typography paragraph>
            Proovitest on päris testi lühem variant: selles on esitatud vaid 12 sõna. Nendest 2 esimest sõna (RIIUL,
            KAPSAS) on nummerdamata, need on mõeldud katsetamiseks ja on samad iga testisoorituse puhul.
          </Typography>
          <Typography paragraph>Proovitesti sisu jääb alati samaks, kuid päristest on iga kord unikaalne.</Typography>
          <CardActions sx={{ justifyContent: "center", mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <VButton text="Tagasi avalehele" type="outlined" navigate="/" />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <VButton text="Edasi" onClick={() => props.startTimer()} />
              </Grid>
            </Grid>
          </CardActions>
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default EndDialog;
